import api from "../hooks/api";
import { API_URLS } from "../App";
import { CompoundPriceHistory } from "../model/CompoundPriceHistory";

/** Admin-only: compound base-price history + campaign overrides. GET only. */
export async function fetchCompoundPriceHistory(
  compoundId: string,
  resellerErpRef?: string,
): Promise<CompoundPriceHistory> {
  const params = resellerErpRef
    ? { reseller_erp_ref: resellerErpRef }
    : undefined;
  const response = await api.get(
    `${API_URLS.COMPOUNDS}/${encodeURIComponent(compoundId)}/price-history`,
    { params },
  );
  return response.data as CompoundPriceHistory;
}
